<template>
  <!-- 合同模板管理 -->
  <div>
    <div v-show="HtmbGl">
      <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">合同模板管理</div>
      <!-- 主体 -->
      <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
        <!-- 查询框 -->
        <div style="margin-left:3%">
          <div style="height:40px"></div>
          <span>员工合同分类 </span>
          <el-select v-model="condition.dictionaries_name" style="margin-left:10px;width:160px" placeholder="请选择分类">
            <el-option v-for="item in staffList" :key="item.id" :label="item.data" :value="item.id">
            </el-option>
          </el-select>

          <div style="display:inline-block;margin-left:20px">
            <span>生效日期 </span>
            <el-date-picker style="width:160px;margin-left:10px" v-model="condition.start_date" type="date"
              placeholder="请选择" value-format="yyyy-MM-dd">
            </el-date-picker>
            <span>&nbsp;-&nbsp;</span>
            <el-date-picker style="width:160px" v-model="condition.end_date" type="date" placeholder="请选择">
            </el-date-picker>
          </div>

          <!-- 按钮 -->
          <div style="display:inline-block;margin-left:50px">
            <el-button type="goon" @click="Find">查询</el-button>
            <el-button type="goon" @click="Dell()">删除</el-button>
            <el-button type="addbtn" @click="add()">新增</el-button>
          </div>
        </div>

        <!-- 表格 -->
        <div style="margin:3% 3% 0 3%">
          <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}" :row-class-name="tableRowClassName"
            ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;" height="540"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column align="center" label="序号" width="50">
              <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
            </el-table-column>
            <el-table-column prop="template_name" align="center" label="员工合同模板名称"></el-table-column>
            <el-table-column prop="dictionaries_name" align="center" label="员工合同分类"></el-table-column>
            <el-table-column prop="template_date" align="center" label="生效日期"></el-table-column>
            <el-table-column prop="" align="center" label="状态" width=100>
              <template slot-scope="scope">
                <img src="../../../assets/stateImg/状态_未生效.png" v-show="scope.row.template_state === '0'" />
                <img src="../../../assets/stateImg/状态_未生效.png" v-show="scope.row.template_state === '3'" />
                <img src="../../../assets/stateImg/状态_已生效.png" v-show="scope.row.template_state === '1'" />
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="300">
              <template slot-scope="scope">
                <img src="../../../assets/详情.png" @click="xiangqing(scope.row)">
                <img src="../../../assets/编辑.png" @click="UpdateFrom(scope.row)">
                <img src="../../../assets/删除.png" @click="Del(scope.row.id)" style="margin-left: 10px" />
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <el-row style="margin-top: 10px; text-align: center;">
            <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
              layout=" prev, pager, next, jumper" :total="total">
            </el-pagination>
          </el-row>
        </div>

      </div>
    </div>
    <add ref="adds" v-show="showadd"></add>
    <xq ref="xqs" v-show="showaxq"></xq>
    <edit ref="edits" v-show="showedit"></edit>
  </div>
</template>

<script>
import add from './HtmbGl_add.vue';
import xq from './HtmbGl_xq.vue';
import edit from './HtmbGl_edit.vue';
import axios from 'axios';
export default {
  components: {
    add: add,
    xq: xq,
    edit: edit,
  },
  data() {
    return {
      page_num: 1,
      page_size: 10,
      total: 0,
      tableData: [],
      staffList: [],
      ruleForm: {
        id: '',
        template_name: '',
        dictionaries_name: '',
        template_date: '',
        template_content: '',
        template_url: '',
        template_state: '',
        reviewer_name: '',
        reviewer_date: '',
        reject_reason: '',
        dictionaries_name: '',
        start_date: '',
        end_date: '',
      },
      // 权限
      HtmbGl: true,
      showadd: false,
      showaxq: false,
      showedit: false,
      ids: [],
      //条件
      condition: {
        id: '',
        dictionaries_name: '',
        start_date: '',
        end_date: '',
      },
    };
  },
  methods: {
    // 全选
    handleSelectionChange(e) {
      this.ids = [];
      e.forEach((item) => {
        this.ids.push(item.id);
      });
    },
    // 返回
    Return() {
      this.showadd = false;
      this.showaxq = false;
      this.showedit = false;
      this.HtmbGl = true;
    },
    // 新增
    add() {
      this.HtmbGl = false;
      this.showadd = true;
      this.$refs.adds.add;
    },
    // 操作详情
    xiangqing(e) {
      this.HtmbGl = false;
      this.showaxq = true;
      this.$refs.xqs.xq;
      this.ruleForm.dictionaries_name = e.dictionaries_name;
      this.ruleForm.start_date = e.start_date;
      this.ruleForm.end_date = e.end_date;
      this.ruleForm.template_date = e.template_date;
      this.ruleForm.template_content = e.template_content;
      this.ruleForm.template_url = e.template_url;
      this.ruleForm.template_state = e.template_state;
      this.ruleForm.reviewer_name = e.reviewer_name;
      this.ruleForm.reviewer_date = e.reviewer_date;
      this.ruleForm.reject_reason = e.reject_reason;
      this.ruleForm.dictionaries_name = e.dictionaries_name;
      this.ruleForm.start_date = e.start_date;
      this.ruleForm.end_date = e.end_date;
      this.ruleForm.template_name = e.template_name;
    },
    // 操作修改
    UpdateFrom(e) {
      this.HtmbGl = false;
      this.showedit = true;
      this.$refs.edits.edit;
      this.ruleForm.id = e.id;
      this.ruleForm.dictionaries_name = e.dictionaries_name;
      this.ruleForm.start_date = e.start_date;
      this.ruleForm.end_date = e.end_date;
      this.ruleForm.template_date = e.template_date;
      this.ruleForm.template_content = e.template_content;
      this.ruleForm.template_url = e.template_url;
      this.ruleForm.template_state = e.template_state;
      this.ruleForm.reviewer_name = e.reviewer_name;
      this.ruleForm.reviewer_date = e.reviewer_date;
      this.ruleForm.reject_reason = e.reject_reason;
      this.ruleForm.dictionaries_name = e.dictionaries_name;
      this.ruleForm.start_date = e.start_date;
      this.ruleForm.end_date = e.end_date;
      this.ruleForm.template_name = e.template_name;
    },
    // 操作删除
    async Del(e) {
      var url = 'template/del';
      var record = {
        ids: [e],
      };
      var data = await this.$globals.AxiosPost(url, record);
      if (data === '-2000') {
        this.$message.error('服务器未响应！请稍后重试');
      } else {
        var code = data.code;
        var data = data.data;
        if (code === '200') {
          this.$message.success(data);
          this.trash();
          this.Find();
        } else {
          this.$message.warning(data);
        }
      }
    },
    //删除
    Dell(e) {
      var ids;
      if (e === null || e === '' || e === undefined) {
        if (this.ids === null || this.ids.length <= 0) {
          this.$message.warning('请先选择操作数据！');
          return false;
        }
        ids = this.ids;
      } else {
        ids = [e];
      }

      const url = this.$globals.http + 'template/del';
      axios
        .post(url, {
          ids: ids,
        })
        .then((response) => {
          var code = response.data.code;
          var data = response.data.data;

          if (code === '200') {
            this.$message.success(data);
            this.Find();
          } else {
            this.$message.warning('请求失败！请稍后重试');
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error('服务器未响应！请稍后重试');
        });
    },
    //查询
    async Find() {
      var url = 'template/selectAll';
      var record = {
        page_num: this.page_num,
        page_size: this.page_size,
        data_grouping: 'HtmbGl',
        template_name: this.ruleForm.template_name,
        dictionaries_name: this.ruleForm.dictionaries_name,
        start_date: this.ruleForm.start_date,
        end_date: this.ruleForm.end_date,
        template_content: this.ruleForm.template_content,
        template_url: this.ruleForm.template_url,
        template_state: this.ruleForm.template_state,
        reviewer_name: this.ruleForm.reviewer_name,
        reviewer_date: this.ruleForm.reviewer_date,
        reject_reason: this.ruleForm.reject_reason,
        dictionaries_name: this.ruleForm.dictionaries_name,
        start_date: this.ruleForm.start_date,
        end_date: this.ruleForm.end_date,
      };
      var data = await this.$globals.AxiosPost(url, record);
      if (data === '-2000') {
        this.$message.error('服务器未响应！请稍后重试');
      } else {
        var code = data.code;
        var data = data.data;
        if (code === '200') {
          this.tableData = data.list;
          this.total = data.total;
        } else {
          this.$message.warning('请求失败！请稍后重试');
        }
      }
    },
    //分页
    handleCurrentChange(val) {
      this.page_num = val;
      this.Find();
    },
    //清除数据
    trash() {
      this.ruleForm.id = '';
      this.ruleForm.template_name = '';
      this.ruleForm.dictionaries_name = '';
      this.ruleForm.template_date = '';
      this.ruleForm.template_content = '';
      this.ruleForm.template_url = '';
      this.ruleForm.template_state = '';
      this.ruleForm.reviewer_name = '';
      this.ruleForm.reviewer_date = '';
      this.ruleForm.reject_reason = '';
      this.ruleForm.dictionaries_name = '';
      this.ruleForm.start_date = '';
      this.ruleForm.end_date = '';
    },
  },
  async created() {
    this.Find();
    var staffList = await this.$globals.AxiosPost('dictionaries/selectFind', {
      data_grouping: 'contract_type',
    });
    this.staffList = staffList.data;
  },
};
</script>

<style>
.el-button--goon:focus,
.el-button--goon:hover {
  background: #006e4b;
  border-color: #05573d;
  color: #fff;
}
.el-button--addbtn:focus,
.el-button--addbtn:hover {
  background: #fff;
  border-color: #05573d;
  color: #006e4b;
}
.el-button--goon {
  color: #fff;
  background-color: #006e4b;
  border-color: #006e4b;
  font-size: 15px;
  width: 85px;
}
.el-button--addbtn {
  color: #006e4b;
  background-color: #fff;
  border-color: #006e4b;
  font-size: 15px;
  width: 85px;
}
.el-table .warning-row {
  background: oldlace;
}
.el-table .success-row {
  background: #f0f9eb;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #006e4b;
  border-color: #006e4b;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #006e4b;
}
.el-checkbox__inner:hover {
  border-color: #006e4b;
}
</style>


// WEBPACK FOOTER //
// HtmbGl.vue?581c13c8